<template>
      <div class="studentRequirementCreate">
        <v-breadcrumbs>
          <v-breadcrumbs-item :exact="true" :to="{ name: 'home', params: {} }"
            >Home</v-breadcrumbs-item
          >
          <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
          <v-breadcrumbs-item :exact="true" :to="{ name: 'studentRequirement', params: {} }">
          Student Requirement
          </v-breadcrumbs-item>
          <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
          <v-breadcrumbs-item :to="{ name: 'studentRequirementCreate', params: {} }">
            Create Student Requirement
          </v-breadcrumbs-item>
        </v-breadcrumbs>

        <v-card>
          <v-card-title>Create Student Requirement</v-card-title>
          <v-card-text>
            <studentRequirement-form></studentRequirement-form>
          </v-card-text>
        </v-card>
      </div>
    </template>
    <script>
    import StudentRequirementForm from './StudentRequirementForm.vue';

    export default {
      name: 'studentRequirement',
      components: {
        StudentRequirementForm
      },
      created() {
        this.$emit("showParent", false);
      }
    }
    </script>
    